// @ts-check
import React from 'react';
import { connect } from 'react-redux';
import AgentPortalSidebar from './AgentPortalSidebar';
import AgentPortalNav from './AgentPortalNav';
import FlashMessage from 'shared/components/FlashMessage';
import ReferralNotification from 'agent_portal/components/ReferralNotification';
import {
  HeaderLogo,
  WelcomeMessage,
  PortalFooter,
} from 'shared/containers/portal_layout';
import { HelpWidget } from 'agent_portal/components/HelpWidget';
import { RebrandNotice } from 'agent_portal/components/RebrandNotice';

const AgentPortalLayout = (props) => {
  const { subdomainLogoUrl, currentAgent, children, ...rest } = props;
  return (
    <div className="wmi_admin_portal_layout_content">
      <HeaderLogo path="/a/portal/dashboard" logoUrl={subdomainLogoUrl} />
      <WelcomeMessage
        name={`${currentAgent.firstName} ${currentAgent.lastName}`}
      />
      <AgentPortalNav currentEmployment={currentAgent.currentEmployment} />
      <FlashMessage />
      <ReferralNotification />
      <AgentPortalSidebar currentAgent={currentAgent} {...rest} />

      <div id="content">
        {children}

        <PortalFooter />
      </div>
      <div className="right-6 bottom-6 fixed z-10">
        <HelpWidget />
      </div>

      <RebrandNotice currentAgent={currentAgent} />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    subdomainLogoUrl: state.session.subdomainLogoUrl
      ? state.session.subdomainLogoUrl
      : state.session.subdomainOrganization
      ? state.session.subdomainOrganization.logoUrl
      : undefined,
    currentAgent: state.currentAgent,
  };
}

export default connect(mapStateToProps)(AgentPortalLayout);
